import * as _ from 'lodash';
import { DynamicQueryEvent } from 'common/dynamicquery/dynamic-query-events.factory';

/**
 * ChatBase
 *
 * @param chat
 * @constructor
 */
class ChatBase {
  public OperatorID;
  public Started;
  public Ended;
  public Disconnected;
  public Closed;
  public LastAssignedAnswered;
  public CannedMessageID;
  public VisitID;
  public VisitorID;

  static comparator(chat1, chat2) {
    return chat1.ChatID === chat2.ChatID;
  }

  static wrap(event: Partial<DynamicQueryEvent>): ChatBase {
    return new ChatBase(event.data);
  }

  constructor(chat) {
    _.assign(this, chat);
  }

  isAnswerable(operator) {
    return !this.isAnswered() &&
      this.isAlive() &&
      (this.isMyChat(operator) || this.isUnassigned());
  }

  isConversationActive(operator) {
    return !this.Ended && !this.Closed && this.isMyChat(operator);
  }

  isEndable() {
    return this.Started && !this.Ended;
  }

  isMyChat(operator) {
    return this.OperatorID === operator.id;
  }

  isUnassigned() {
    const unassignedOperatorId = -1;
    return this.OperatorID === unassignedOperatorId || this.OperatorID === null;
  }

  isAlive() {
    return this.Started && !this.Ended && !this.Closed;
  }

  isEnded() {
    return !!this.Ended && !this.Closed;
  }

  isClosed() {
    return !!this.Ended && !!this.Closed;
  }

  isDisconnected() {
    return !!this.Disconnected && !this.Ended;
  }

  isAnswered() {
    return this.LastAssignedAnswered;
  }
}

export { ChatBase };
